import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/rating/rating-down.svg';

const RatingDown = (props) => (
   <Icon { ...props }/>
);

export default RatingDown;
